import { useState } from 'react';
import { Copy } from 'lucide-react';

export interface CopyIdButtonProps {
  value: string;
  label: string;
}

export function CopyIdButton({ value, label }: CopyIdButtonProps) {
  const [copied, setCopied] = useState(false);
  const copyTooltip = copied ? 'Copied!' : label;

  async function handleCopy() {
    await navigator.clipboard?.writeText(value);
    setCopied(true);
  }

  function resetCopiedState() {
    setCopied(false);
  }

  return (
    <div className="group/copy relative" onMouseLeave={resetCopiedState} onBlur={resetCopiedState}>
      <button
        type="button"
        className="focus-ring inline-flex h-6 w-6 items-center justify-center rounded-full text-neutral-500 opacity-0 transition group-hover:opacity-100 group-focus-within:opacity-100 hover:bg-backoffice-50 hover:text-neutral-900"
        aria-label={label}
        title={copyTooltip}
        onClick={(event) => {
          event.stopPropagation();
          void handleCopy();
        }}
        onKeyDown={(event) => event.stopPropagation()}
      >
        <Copy className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
      <span className="pointer-events-none absolute bottom-full left-1/2 mb-2 hidden -translate-x-1/2 whitespace-nowrap rounded-md bg-neutral-900 px-2 py-1 text-[11px] font-medium text-white group-hover/copy:block group-focus-within/copy:block">
        {copyTooltip}
      </span>
    </div>
  );
}
